import { render, staticRenderFns } from "./add-messages.vue?vue&type=template&id=db43a684&scoped=true"
import script from "./add-messages.vue?vue&type=script&lang=js"
export * from "./add-messages.vue?vue&type=script&lang=js"
import style0 from "./add-messages.vue?vue&type=style&index=0&id=db43a684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db43a684",
  null
  
)

export default component.exports